import { firebaseConfig, googleMapsApiKey } from './firebase-config';

export const environment = {
    production: false,
    googleMapsUrl: "https://maps.googleapis.com/maps/api/js?key=",
    googleMapsApiKey,
    firebaseConfig
};